export const setShowFirstTimePopup = (data) => {
  console.log("set", data)
  return {
    type: "UPDATE_POPUP_REDUCER",
    ...data,
  };
};

export const setShowTutorialPopup = (data) => {
  return {
    type: "UPDATE_POPUP_REDUCER",
    ...data,
  };
};

export const resetShowFirstTimePopup = () => {
  return {
    type: "UPDATE_POPUP_REDUCER",
    showFirstTimePopup: false,
    firstTimePopupType: "",
    customisedPosition: null,
    popupDismissable: false,
  };
};

export const resetShowTutorialPopup = () => {
  return {
    type: "UPDATE_POPUP_REDUCER",
    showTutorialPopup: false,
    tutorialPopupType: "",
    tutorialCustomisedPosition: null,
    tutorialPopupDismissable: false,
  };
};

export const setTutorialImageDimension = (data) => {
  return {
    type: "UPDATE_POPUP_REDUCER",
    ...data,
  };
}